module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAMAAADzN3VRAAAAAXNSR0IB2cksfwAAADZQTFRFAAAAKXn/Knj/KXn/KXn/KXn/Knf/KHr/KHn/KHj/KXn/Knr/KHn/KXn/KXn/KXn/KXn/KXn/xqaC8QAAABJ0Uk5TAFCfv+//T2BfIM8w0PDfoMDgHLUjdwAAAJFJREFUeJx9kuESxBAMhKPNnlNy9P1f9kzRYqT7i3wTSTaIqsy2M3jfPjTKMpr428XdgV6Ha8AzRrGvGTPIqGSFds/n+8GrOBYENl9kSX55DiwJDEWFREoKSaXM5MjVOEEhUHPkpY7emz6P4sH56tvS61D287zXJHWrfkbi738QBhBcN7V90k47OWJiEkiKpgX+6qwJ0QONQE4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./app/images/add_employee.png
// module id = 3841
// module chunks = 0